module.exports = __webpack_public_path__ + "pickup-point-3SM.png";